const generalKeys = [
  "role",
  "userId",
  "appTheme",
  "userRole",
  "userName",
  "pageSize",
  "authToken",
  "timestamp",
  "physician",
  "clinicName",
  "primaryRole",
  "hasRPMDevices",
  "clinicReviewer",
  "clinii_user_id",
  "passwordTimeStamp",
  "followingHospitals",
  "followingPhysicians",
  "isFollowingHospital",
  "isFollowingPhysician",
];

/**
 * Below userSpecificKeys localstorage values should be stored even after logout
 */
const userSpecificKeys = [
  "isDrawerOpen",
  "myPatientsToggled",
  "patientTableColumn",
  "transmissionTableColumn",
];

const removableKeys = [...generalKeys];
const localStorageKeys = [...generalKeys, ...userSpecificKeys];

const clearLocalStorageKeysAfterLogout = (keys = removableKeys) => {
  keys.forEach((key) => localStorage.removeItem(key));
};

const setLocalStorageKeys = (data = {}) => {
  for (const key in data) {
    const value =
      typeof data[key] === "object" && data[key] !== null
        ? JSON.stringify(data[key])
        : String(data[key]);

    localStorage.setItem(key, value);
  }
};

export {
  localStorageKeys,
  setLocalStorageKeys,
  clearLocalStorageKeysAfterLogout,
};
